import {Col, Row} from "antd";
import React, {useEffect} from "react";
import {useCourierWalletPaymentSubTab} from "./useCourierWalletPaymentSubTab";
import {CourierWalletPaymentsList} from "./courierWalletPaymentsList/CourierWalletPaymentsList";
import {CourierWalletPaymentDetail} from "./courierWalletPaymentDetail/CourierWalletPaymentDetail";
import moment from "moment";
import {useStore} from "@vigo/hooks";

export const CourierWalletPaymentSubTab = ({
    courier,
    canRender = false,
    walletStartDate,
    walletStartDateRecall,
    selectedDateRange,
    onDateRangeChange
}) => {
    const stores = useStore();
    const isAgency = stores.meStore.checkRole("isAgency");
    const {
        courierWalletPaymentsResultLoading,
        courierWalletPayments,
        selectedCourierWalletPayment,
        handleCourierWalletPaymentSelect
    } = useCourierWalletPaymentSubTab({courier, canRender, selectedDateRange, onDateRangeChange});

    useEffect(() => {
        if (canRender && walletStartDateRecall && onDateRangeChange) {
            onDateRangeChange([moment(walletStartDate), selectedDateRange?.[1]]);
        }
    }, [walletStartDateRecall]);

    return (
        <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={isAgency ? 24 : 8}>
                <CourierWalletPaymentsList
                    payments={courierWalletPayments}
                    onItemSelect={handleCourierWalletPaymentSelect}
                    selectedItem={selectedCourierWalletPayment}
                    selectedDateRange={selectedDateRange}
                    onDateRangeChange={onDateRangeChange}
                    loading={courierWalletPaymentsResultLoading}
                />
            </Col>
            {!isAgency && (
                <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                    {selectedCourierWalletPayment && (
                        <CourierWalletPaymentDetail
                            payment={selectedCourierWalletPayment}
                            loading={courierWalletPaymentsResultLoading}
                        />
                    )}
                </Col>
            )}
        </Row>
    );
};
